import { render } from "./LightboxProductsMostPurchased.vue?vue&type=template&id=62be6313"
import script from "./LightboxProductsMostPurchased.vue?vue&type=script&lang=js"
export * from "./LightboxProductsMostPurchased.vue?vue&type=script&lang=js"

import exportComponent from "/var/pmweb/builder/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__